// extracted by mini-css-extract-plugin
export var formContainer = "_c9-0";
export var message = "_c9-1";